import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";
import { Plus, Minus } from "lucide-react";

export default function AdminClients() {
  const [clients, setClients] = useState([]);
  const [editing, setEditing] = useState(null);
  const [delta, setDelta] = useState("");
  const [reason, setReason] = useState("");

  const load = () => api.get("/admin/clients").then((r) => setClients(r.data));
  useEffect(() => { load(); }, []);

  const adjust = async (sign) => {
    const v = parseInt(delta);
    if (!v || v <= 0) { toast.error("Indiquez un nombre de points valide"); return; }
    try {
      await api.post(`/admin/clients/${editing.id}/points`, { delta: sign * v, reason });
      toast.success("Points ajustés");
      setEditing(null); setDelta(""); setReason("");
      load();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Erreur");
    }
  };

  return (
    <div className="max-w-7xl mx-auto px-6 md:px-10 py-12" data-testid="admin-clients-page">
      <div className="fade-up">
        <div className="label-eyebrow mb-3">Membres</div>
        <h1 className="font-display text-5xl">Clients</h1>
        <p className="text-[#a3a8a4] mt-2">Attribuez ou retirez des points selon les achats en boutique.</p>
      </div>

      <div className="border border-[rgba(253,251,247,0.08)] mt-10 overflow-x-auto fade-up-delay-1">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-[rgba(253,251,247,0.08)] text-left">
              <th className="px-4 py-3 label-eyebrow">Prénom</th>
              <th className="px-4 py-3 label-eyebrow">Email</th>
              <th className="px-4 py-3 label-eyebrow">Points</th>
              <th className="px-4 py-3 label-eyebrow">Inscrit</th>
              <th className="px-4 py-3 label-eyebrow text-right">Action</th>
            </tr>
          </thead>
          <tbody>
            {clients.length === 0 && <tr><td colSpan={5} className="p-8 text-center text-[#a3a8a4]">Aucun client inscrit.</td></tr>}
            {clients.map((c) => (
              <tr key={c.id} className="border-b border-[rgba(253,251,247,0.05)] last:border-0 hover:bg-[#1a241b]/30" data-testid={`admin-client-${c.id}`}>
                <td className="px-4 py-3">{c.firstName}</td>
                <td className="px-4 py-3 text-[#a3a8a4]">{c.email}</td>
                <td className="px-4 py-3 gold-text font-medium">{c.points}</td>
                <td className="px-4 py-3 text-[#a3a8a4]">{new Date(c.created_at).toLocaleDateString("fr-FR")}</td>
                <td className="px-4 py-3 text-right">
                  <button onClick={() => setEditing(c)} className="px-4 py-1.5 border border-[#d4af37] text-[#d4af37] hover:bg-[#d4af37]/10 text-xs uppercase tracking-widest" data-testid={`adjust-${c.id}`}>Ajuster pts</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {editing && (
        <div className="fixed inset-0 bg-black/80 backdrop-blur-md z-50 flex items-center justify-center p-4" onClick={() => setEditing(null)} data-testid="adjust-modal">
          <div onClick={(e)=>e.stopPropagation()} className="w-full max-w-md bg-[#0a0e0b] border border-[rgba(253,251,247,0.08)] p-8 space-y-4">
            <div className="label-eyebrow">{editing.email}</div>
            <h3 className="font-display text-3xl">Ajuster les points</h3>
            <div className="text-sm text-[#a3a8a4]">Solde actuel : <span className="gold-text">{editing.points} pts</span></div>
            <label className="block">
              <span className="label-eyebrow block mb-2">Nombre de points</span>
              <input type="number" min="1" value={delta} onChange={(e)=>setDelta(e.target.value)} data-testid="adjust-points-input" className="w-full bg-[#050706] border border-[rgba(253,251,247,0.1)] px-4 py-3 focus:border-[#d4af37] focus:outline-none"/>
            </label>
            <label className="block">
              <span className="label-eyebrow block mb-2">Motif (optionnel)</span>
              <input value={reason} onChange={(e)=>setReason(e.target.value)} placeholder="Ex: Achat parfum 50ml" data-testid="adjust-reason-input" className="w-full bg-[#050706] border border-[rgba(253,251,247,0.1)] px-4 py-3 focus:border-[#d4af37] focus:outline-none"/>
            </label>
            <div className="flex gap-3 pt-2">
              <button onClick={() => adjust(1)} className="flex-1 bg-[#d4af37] text-black px-5 py-3 text-xs uppercase tracking-widest hover:bg-[#e6c27a] inline-flex items-center justify-center gap-2" data-testid="adjust-add-btn">
                <Plus size={14}/> Créditer
              </button>
              <button onClick={() => adjust(-1)} className="flex-1 border border-red-500 text-red-400 px-5 py-3 text-xs uppercase tracking-widest hover:bg-red-500/10 inline-flex items-center justify-center gap-2" data-testid="adjust-remove-btn">
                <Minus size={14}/> Débiter
              </button>
            </div>
            <button onClick={() => setEditing(null)} className="w-full border border-[rgba(253,251,247,0.1)] px-5 py-3 text-xs uppercase tracking-widest hover:border-[#d4af37]" data-testid="adjust-cancel-btn">Annuler</button>
          </div>
        </div>
      )}
    </div>
  );
}
